import { Component, ViewChild, TemplateRef, Input, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { PaginationService } from '../../PaginationService';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { AuService } from '../au/au.service';
@Component({
  selector: 'app-parallel-workflow',
  templateUrl: 'parallel-workflow.html',
  styleUrls: ['parallel-workflow.scss']
})

export class ParallelWorkflowComponent implements OnInit {
  @Input() showGrid: boolean;
  isProcessing = false;
  columnname: any;
  _temp: any = {};
  columnLists: any = {};
  oneQmsUsersDataForTable1: any = [];
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  oneQmsUsersDataForTable1Temp: any;
  dataTypeList: any = [];
  array: any = [];
  oneQmsOrgUsersDetails: any;
  searchText: any;

  codelistGroupList: any = [];
  searchValue: any;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  oneQmsUsersDataForFilter !: any[];
  dropDownDataForModule: any = [];
  makeStickyColumns: any;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, public qmsService: qmsService, private readonly elem: ElementRef,
    public auService: AuService) { }

  ngOnInit(): void {
    this.isProcessing = true;
    this.getCall();
  }

  getCall() {
    this.isProcessing = true;
    this.oneQmsUsersDataForTable1 = [];
    const data = {

      gridName: "PARALLEL_WORKFLOWS"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "PARALLEL_WORKFLOWS",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          codelistGroup: null,
          manualEntryDataFields: response.manualEntryDataFields,
          refNo: this.qmsService.activityId,
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.oneQmsUsersDataForTable1 = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const element of this.oneQmsUsersDataForTable1) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    element[dataType.columnName] = element[dataType.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.oneQmsUsersDataForTable1;
            this.collectionSize = this.oneQmsUsersDataForTable1.length;
            this.totalPages = Math.ceil(this.oneQmsUsersDataForTable1.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.visibleDataGrid = true;
  }



  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.oneQmsUsersDataForTable1.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.oneQmsUsersDataForTable1.length, page, this.perPage, targetpage);
    this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.oneQmsUsersDataForTable1.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.oneQmsUsersDataForTable1) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.oneQmsUsersDataForTable1) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.oneQmsUsersDataForTable1[this.previousIdx].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;

    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.oneQmsUsersDataForTable1.some((list: any) => list.childCheckBoxs);
    this.previousIdx = idx;
  }

  /* End Multi Row Select */
  visibleAuditTrail: any;
  searchManagerParentCheckBox: boolean = false;
  searchManagerChildCheckBoxs: boolean = false;
  searchManagerChildCheckBoxsMenu: boolean = false;
  searchManagerDataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      for (const element of this.getOneQmsUsersVwDetailsTableData) {
        element.searchManagerChildCheckBoxs = true;
      }
    } else {
      for (const element of this.getOneQmsUsersVwDetailsTableData) {
        element.searchManagerChildCheckBoxs = false;
      }
    }
  }

  getSelectedUserId: any;
  getSelectedUserName: string;
  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  };

  onClick(event: any) {
  }
  onlinkClick(event: any) {

    this.qmsService.workflowId = event.WORKFLOW_ID;
    this.router.navigate(['dashboard/parallelworkflowDetails']);
  }
  addworkflow: any;
  refreshGridData() { console.log() };
  async openAddPopup() {
    this.isProcessing = true;

    const extensionCheck = await this.qmsService.validateExtension({
      refNo: this.qmsService.activityId,
      extensionFor: "Activity"
    });

    if (this.qmsService.activity.status == "In Progress" && extensionCheck) {
      setTimeout(() => {
        this.showSnackBar(this.qmsService.extensionResult, 'E');
      }, 0);
    } else {
      this.addworkflow = true;
    }

    this.isProcessing = false;
  }

  onworkflowChildValueEmitted() {
    this.getCall();
    this.addworkflow = false;
  }


  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  workflowId: number = 0;
  popupTitle: any;
  deleteReason: any = null;
  deleteCodelist(deletingData: any) {
    this.popupTitle = "Delete Workflow";
    this.workflowId = deletingData.WORKFLOW_ID;
    this.deleteReason = null;
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }
  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }
  deleteFunction(deletingData: any) {
    if (this.deleteReason) {
      this.isProcessing = true;

      const deleting_obj = {
        workflowId: this.workflowId,
        deleteReason: this.deleteReason,
      }

      this.appService.deleteParallelWorkflow(deleting_obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDelete() {
    this.visibleDeletePopup.close();
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  idMapping: Record<string, string> = { 'CR': this.qmsService.activity.crId, 'CAPA': this.qmsService.activity.capaId, 'DV': this.qmsService.activity.dvId, 'AU': this.qmsService.activity.auId, 'IN': this.qmsService.activity.inId, 'QI': this.qmsService.activity.qiId, 'CC': this.qmsService.activity.ccId };
  auditTrail: any = {};
  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, workFlow: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : workFlow.WORKFLOW_ID;
    this.auditTrail.viewType = viewType;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'PARALLEL_WORKFLOWS';
    let reasonText = '';

    if (viewType !== 'overAll') {
      const reason = workFlow.REASON_FOR_WORKFLOW;
      reasonText =
        reason.length > 20 ? ' - ' + reason.slice(0, 20) + '...' : ' - ' + reason;
    }

    this.auditTrail.report_And_Popup_Name =
      this.qmsService.moduleName +
      ' Parallel Workflow Audit Trail [' +
      this.idMapping[this.qmsService.moduleName] +
      reasonText +
      ']'; this.dynamicAuditTrailComponent.triggerTrail(workFlow);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsService.moduleName + '  Parallel Workflow Report [' + this.idMapping[this.qmsService.moduleName] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qmsService.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  status: any = ['In Progress', 'PhaseII In Progress', 'PhaseIII In Progress', 'Findings In Progress'];

  addNewControl() {
    return this.status.includes(this.qmsService.activity.status) &&
      (((this.qmsService.moduleName == 'CR' || this.qmsService.moduleName == 'CAPA' || this.qmsService.moduleName == 'DV' || this.qmsService.moduleName == 'OOS') && this.qmsService.activity.owner == +this.message.getUserId()) ||
        ((this.qmsService.moduleName == 'IN' || this.qmsService.moduleName == 'QI' || this.qmsService.moduleName == 'CC') && this.qmsService.activity.evaluator == +this.message.getUserId()) ||
        (this.qmsService.moduleName == 'AU' && this.qmsService.activity.leadAuditor == +this.message.getUserId()!))
  }

  public focusEmpty(): void {
    console.log();
  }
}
